import styled from "styled-components";

export default styled.div`
	display: flex;
	flex-direction: column;
	margin: 10px;
	flex: 1;
	max-width: 100%;
	min-width: 300px;
	font-size: 11px;
	weight: 700;
`;
